"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonValidateException = void 0;
const error_interface_1 = require("@sigmasms/shared-types/exceptions/error.interface");
const common_exception_1 = require("../../common.exception");
class CommonValidateException extends common_exception_1.CommonException {
    constructor(input = {}) {
        var _a;
        input.type = 'ValidateError';
        input.message = (_a = input.message) !== null && _a !== void 0 ? _a : 'Ошибка валидации';
        input.transportPayload = { httpStatus: error_interface_1.HttpStatus.BAD_REQUEST };
        super(input);
    }
}
exports.CommonValidateException = CommonValidateException;
//# sourceMappingURL=validate-error.exception.js.map